export const RENDER_DISTANCE = 6;
export const TICK_RATE = 20;
export const TICK_MS = 1000 / TICK_RATE;
export const GRAVITY = -28;
export const JUMP_VELOCITY = 9;
export const PLAYER_SPEED = 4.3;
export const PLAYER_SPRINT_SPEED = 5.6;
export const PLAYER_WIDTH = 0.6;
export const PLAYER_HEIGHT = 1.8;
export const PLAYER_EYE_HEIGHT = 1.62;
export const BLOCK_REACH = 5;
export const TEXTURE_SIZE = 16;
export const ATLAS_SIZE = 512;
export const TILES_PER_ROW = ATLAS_SIZE / TEXTURE_SIZE;
export const DAY_LENGTH = 1200; // seconds (20 minutes)
export const FOG_NEAR_FACTOR = 0.6;
export const FOG_FAR_FACTOR = 0.9;
export const MAX_LIGHT_LEVEL = 15;
export const HOTBAR_SLOTS = 9;
export const INVENTORY_ROWS = 4;
export const INVENTORY_COLS = 9;
export const INVENTORY_SIZE = INVENTORY_ROWS * INVENTORY_COLS;
export const MAX_STACK_SIZE = 64;
